// APIs docs: https://developers.podbean.com/apidoc/widget
import {
  recordPodbeanPlayStartStatistic,
  recordPodbeanPlayFinishedStatistic,
} from '../services/statistics-service';

export default function bootstrap() {
  $(() => {
    function register(player) {
      // eslint-disable-next-line no-undef
      const widget = new PB(player);

      const wireId = $(player).parents('article.wire').data().id;

      widget.bind('PB.Widget.Events.PLAY', () => {
        recordPodbeanPlayStartStatistic(wireId);
      });

      widget.bind('PB.Widget.Events.FINISH', () => {
        recordPodbeanPlayFinishedStatistic(wireId);
      });
    }

    [
      'iframe[src^="https://www.podbean.com/media/player/"]',
      'iframe[src^="https://www.podbean.com/player-v2"]',
    ].forEach(selector => {
      $(`${selector}`).each((index, player) => register(player));
    });
  });
}
